import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import Calendar from '../../Calendar/Calendar';

class PopupCalendar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.close = this.close.bind(this);
    this.state = { date: null };
  }

  handleChange({ selectedElement: element, selectedDate }) {
    this.setState({ date: selectedDate, trigger: null }, () =>
      this.openTooltip(element),
    );
  }

  openTooltip(element) {
    this.setState({ trigger: element }, () => {
      const { date } = this.state;
      this.props.onChange({ date });
    });
  }

  close() {
    this.setState({ trigger: null });
  }

  render() {
    return (
      <div>
        <Calendar
          onChange={this.handleChange}
          close={this.close}
          getDayStyle={this.props.getDayStyle}
        />
        <Popup
          open={!!this.state.trigger}
          context={this.state.trigger}
          position="top center"
          className="availability-small-popup"
        >
          {this.props.children}
        </Popup>
      </div>
    );
  }
}

PopupCalendar.propTypes = {
  children: PropTypes.array,
  onChange: PropTypes.func,
  getDayStyle: PropTypes.func,
};

export default PopupCalendar;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/PopupCalendar/PopupCalendar.js